import React, { useState } from 'react';
import { Button, Grid, IconButton, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { getType } from 'typesafe-actions';
import ChangePassword from '../../../features/account/changePassword/changePassword';
import { logoutActions } from '../../actions/auth.actions';
import PasswordIcon from '@material-ui/icons/VpnKey';
import LogoutIcon from '@material-ui/icons/ExitToApp';

export interface IProps {
  isCollapsed?: boolean;
}

const MenuNavBtns: React.FC<IProps> = ({ isCollapsed = false }) => {
  const dispatch = useDispatch();

  const [openDialog, setOpenDialog] = useState(false);

  const handleLogout = () => {
    dispatch({ type: getType(logoutActions.request) });
  };
  const onChangePassword = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => setOpenDialog(false);
  return (
    <>
      <ChangePassword open={openDialog} onClose={handleDialogClose} />
      {!isCollapsed ? (
        <Grid container alignItems='center' direction='column'>
          <Button
            onClick={onChangePassword}
            variant='contained'
            size='small'
            className='greyBtn'
          >
            Change Password
          </Button>
          <Button
            onClick={handleLogout}
            variant='contained'
            size='small'
            className='greyBtn'
          >
            Logout
          </Button>
        </Grid>
      ) : (
        <Grid
          container
          direction='column'
          justify='center'
          alignItems='flex-start'
        >
          <Tooltip id='changePassword' title='Change Password'>
            <IconButton onClick={onChangePassword}>
              <PasswordIcon />
            </IconButton>
          </Tooltip>
          <Tooltip id='logoutBtn' title='Logout'>
            <IconButton onClick={handleLogout}>
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      )}
    </>
  );
};

export default MenuNavBtns;
